module.exports = __webpack_public_path__ + "img/JS.111a00a7.png";